'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const faqs = [
  {
    id: 'faq_1',
    question: 'How do I track my shipment?',
    answer: 'Enter your tracking number on our Track Shipment page. You can find your tracking number in your confirmation email or shipping receipt.',
  },
  {
    id: 'faq_2',
    question: 'What are the country-specific codes?',
    answer: 'Each time your package passes through a country, we generate a unique code (e.g., US-NY-20260206-A1B2) for that transit point, providing complete transparency.',
  },
  {
    id: 'faq_3',
    question: 'How long does international shipping take?',
    answer: 'Standard international shipping takes 5-7 business days. Express shipping is available for 2-3 day delivery to major destinations.',
  },
  {
    id: 'faq_4',
    question: 'Do you handle customs clearance?',
    answer: 'Yes, we provide full customs clearance services including documentation, compliance checks, and communication with customs authorities.',
  },
  {
    id: 'faq_5',
    question: 'Is the chatbot available in my language?',
    answer: 'Yes! Our AI chatbot supports English, Spanish, French, German, Chinese, and Arabic. Select your preferred language from the header.',
  },
  {
    id: 'faq_6',
    question: 'What if my package is delayed?',
    answer: 'If your package is delayed, you\'ll receive automatic notifications. Contact our support team for assistance and we\'ll work to resolve the issue immediately.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="bg-card rounded-xl p-8 shadow-card border border-border">
      <h2 className="text-2xl font-heading font-semibold text-foreground mb-6">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {faqs?.map((faq, index) => (
          <div key={faq?.id} className="border-b border-border last:border-0 pb-4 last:pb-0">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between text-left py-2 hover:text-primary transition-colors"
            >
              <span className="font-semibold text-foreground">{faq?.question}</span>
              <Icon
                name="ChevronDownIcon"
                size={20}
                className={`text-muted-foreground transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="mt-2 text-muted-foreground animate-fade-in">
                {faq?.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}